export default () => ({
    activeStep: 0,
    isStepsClickable: [],
    hasNavigation: true
})
